const Separator = ({ className }) => {
  return <div className={`border-t border-grey ${className}`}></div>
}

export default Separator
